import { getImageProps } from 'next/image';
import { canOptimizeImage, toOptimizableSrc } from './media';

/**
 * One image-optimizer URL for `url` at `width` px, for places that need a plain URL rather than an
 * <img srcset>: CSS backgrounds, favicons. It's the 1x candidate getImageProps builds, so widths and
 * qualities stay the ones next.config.ts allows. Anything the optimizer can't serve (external URLs,
 * data URIs) comes back unchanged.
 */
export function optimizedImageUrl(url: string, width: number, quality = 75): string {
  if (!canOptimizeImage(url)) return url;
  const { props } = getImageProps({ src: toOptimizableSrc(url), alt: '', width, height: width, quality });
  return props.srcSet?.split(', ').find((candidate) => candidate.endsWith(' 1x'))?.slice(0, -3) || url;
}
